import React from 'react'

import AppStores from 'components/organisms/AppStores'
import HomeSearch from 'components/organisms/HomeSearch'
import HowItWorks from 'components/organisms/HowItWorks'
import OurSponsors from 'components/organisms/OurSponsors'
import PopularPosts from 'components/organisms/PopularPosts'
import WhatIsLawyerup from 'components/organisms/WhatIsLawyerup'

const Index = () => {
  return (
    <div className='p-homePage'>
      <HomeSearch />
      <PopularPosts />
      <WhatIsLawyerup />
      <HowItWorks />
      <OurSponsors />
      <AppStores />
    </div>
  )
}

export default Index
